// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocalStorage = Symbol('LocalStorage');
